var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _class, _temp;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { provideMapState, VectorLayer } from 'react-openlayers';
import { actions as articlesActions } from '../redux/articles';
import { getFeatureStyle, getActiveSources, loadArticlesIfNeeded } from '../utils/knreise';
import { ensureArticleModuleConfig } from '../hocs/ensureArticleModuleConfig';
import { getArticles } from '../utils/article';

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return bindActionCreators(Object.assign({}, articlesActions), dispatch);
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    stateArticles: state.articles.articles,
    articleLoadState: state.articles.loadState
  };
};

var ArticleLayers = (_temp = _class = function (_React$Component) {
  _inherits(ArticleLayers, _React$Component);

  function ArticleLayers() {
    _classCallCheck(this, ArticleLayers);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  ArticleLayers.prototype.componentDidMount = function componentDidMount() {
    this.checkSources(this.props);
  };

  ArticleLayers.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.checkSources(nextProps);
  };

  ArticleLayers.prototype.checkSources = function checkSources(props) {
    if (props.articles) return;
    this.activeSources.forEach(function (source) {
      var loadState = props.articleLoadState[source];
      var mapCenter = props.mapCenter,
          mapZoom = props.mapZoom,
          mapExtent = props.mapExtent,
          projCode = props.projCode,
          filterColumns = props.filterColumns,
          loadSource = props.loadSource;
      loadArticlesIfNeeded(source, loadState, mapCenter, mapZoom, mapExtent, projCode, filterColumns, 0, loadSource);
    });
  };

  ArticleLayers.prototype.getFeatures = function getFeatures(articles, source) {
    var _props = this.props,
        onArticleOpen = _props.onArticleOpen,
        openArticleId = _props.openArticleId;
    var features = [];
    articles.forEach(function (article) {
      if (article.sources[0] === source && article.olFeature !== 'undefined' && article.id !== openArticleId) {
        var feature = article.olFeature;

        if (!feature.onClick) {
          feature.onClick = function () {
            onArticleOpen(article, true);
          };
        }

        features.push(feature);
      }
    });
    return features;
  };

  ArticleLayers.prototype.sortLayers = function sortLayers(a, b) {
    var aPrio = a.zIndex || 0;
    var bPrio = b.zIndex || 0;
    return aPrio - bPrio;
  };

  ArticleLayers.prototype.render = function render() {
    var _this2 = this;

    var _props2 = this.props,
        sources = _props2.sources,
        useActiveStyle = _props2.useActiveStyle,
        useHoverStyle = _props2.useHoverStyle,
        featureLimit = _props2.featureLimit;
    var articles = this.articles;
    return Object.values(sources).sort(this.sortLayers).map(function (source) {
      var layers = [];
      layers.push(React.createElement(VectorLayer, {
        key: source.dataIndex,
        layerName: source.dataIndex,
        features: featureLimit ? _this2.getFeatures(articles, source.dataIndex).slice(0, featureLimit) : _this2.getFeatures(articles, source.dataIndex),
        featureStyle: getFeatureStyle(source),
        clusterThreshold: source.config.clusterDist,
        maxZoom: source.config.clusterZoomThreshold,
        useActiveStyle: useActiveStyle,
        useHoverStyle: useHoverStyle
      }));

      if (source.config.clusterZoomThreshold) {
        layers.push(React.createElement(VectorLayer, {
          key: source.dataIndex + '_no_cluster',
          layerName: source.dataIndex + '_no_cluster',
          features: featureLimit ? _this2.getFeatures(articles, source.dataIndex).slice(0, featureLimit) : _this2.getFeatures(articles, source.dataIndex),
          featureStyle: getFeatureStyle(source),
          clusterThreshold: 0,
          minZoom: source.config.clusterZoomThreshold,
          useActiveStyle: useActiveStyle,
          useHoverStyle: useHoverStyle
        }));
      }

      return layers;
    });
  };

  _createClass(ArticleLayers, [{
    key: 'activeSources',
    get: function get() {
      var _props3 = this.props,
          activeSources = _props3.activeSources,
          sources = _props3.sources;
      return getActiveSources(activeSources, sources);
    }
  }, {
    key: 'articles',
    get: function get() {
      var _props4 = this.props,
          articles = _props4.articles,
          stateArticles = _props4.stateArticles,
          mapCenter = _props4.mapCenter,
          projCode = _props4.projCode,
          featureLimit = _props4.featureLimit;
      var activeSources = this.activeSources;
      if (articles) return articles;

      if (featureLimit) {
        return getArticles(stateArticles, activeSources, mapCenter, projCode);
      }

      return getArticles(stateArticles, activeSources);
    }
  }]);

  return ArticleLayers;
}(React.Component), _class.defaultProps = {
  filterColumns: {},
  activeSources: []
}, _temp);
ArticleLayers.propTypes = process.env.NODE_ENV !== "production" ? {
  loadSource: PropTypes.func.isRequired,
  activeSources: PropTypes.array,
  sources: PropTypes.array.isRequired,
  mapCenter: PropTypes.any,
  projCode: PropTypes.string,
  featureLimit: PropTypes.number,
  useActiveStyle: PropTypes.bool,
  useHoverStyle: PropTypes.bool,
  onArticleOpen: PropTypes.func.isRequired,
  filterColumns: PropTypes.object,
  articles: PropTypes.array,
  stateArticles: PropTypes.object,
  openArticleId: PropTypes.string
} : {};
export default connect(mapStateToProps, mapDispatchToProps)(ensureArticleModuleConfig(provideMapState(ArticleLayers)));